var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Reports", path: { name: "admin-reports" } }],
          name: "New & Repeat Orders",
        },
      }),
      _vm._v(" "),
      _c(
        "admin-panel",
        {
          attrs: { "with-header": "" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Start date" } },
                            [
                              _c("b-form-datepicker", {
                                model: {
                                  value: _vm.filters.start_date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "start_date", $$v)
                                  },
                                  expression: "filters.start_date",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "End date" } },
                            [
                              _c("b-form-datepicker", {
                                attrs: { min: _vm.filters.start_date },
                                model: {
                                  value: _vm.filters.end_date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "end_date", $$v)
                                  },
                                  expression: "filters.end_date",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Group by" } },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  options: [
                                    { value: "vendor", text: "Vendor" },
                                    { value: "product", text: "Product" },
                                  ],
                                },
                                model: {
                                  value: _vm.filters.group_by,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "group_by", $$v)
                                  },
                                  expression: "filters.group_by",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Repeat definition" } },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  options: [
                                    {
                                      value: "group",
                                      text: "Same vendor / product",
                                    },
                                    {
                                      value: "platform",
                                      text: "Any prior platform order",
                                    },
                                  ],
                                },
                                model: {
                                  value: _vm.filters.repeat_basis,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "repeat_basis", $$v)
                                  },
                                  expression: "filters.repeat_basis",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", disabled: _vm.loading },
                      on: { click: _vm.loadReportData },
                    },
                    [_vm._v("Apply filters")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-2",
                      attrs: { disabled: _vm.loading || !_vm.rows.length },
                      on: { click: _vm.downloadCsv },
                    },
                    [_vm._v("Download CSV")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "New means the buyer has no earlier qualifying order under the selected repeat definition. History before the selected date range is included. Buyers are matched by company, then internal license, then registry license. Unidentified buyers or groups appear as unknown."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Draft, review, cancelled, declined, rejected, deleted and combined-away orders are excluded. Each order counts once per group; product counts across groups may exceed the number of distinct orders. Repeat percentage excludes unknown orders."
            ),
          ]),
          _vm._v(" "),
          _c("b-alert", { attrs: { show: !!_vm.error, variant: "danger" } }, [
            _vm._v(_vm._s(_vm.error)),
          ]),
          _vm._v(" "),
          _c("b-table", {
            attrs: {
              items: _vm.rows,
              fields: _vm.columns,
              responsive: "",
              "show-empty": "",
              striped: "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }